(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-showcase"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const grid = document.querySelector(".brand-showcase__grid");
    if (!grid) return;
    grid.querySelectorAll(".brand-showcase__link").forEach(function(link) {
      link.addEventListener("focus", function() {
        link.querySelector(".brand-showcase__logo").style.filter = "grayscale(0%)";
      });
      link.addEventListener("blur", function() {
        link.querySelector(".brand-showcase__logo").style.filter = "";
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cross-sell-routine"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function buildCardHTML(product) {
    var image = '';
    if (product.featured_image) {
      var src = product.featured_image.replace(/\.\w+$/, function (ext) {
        return '_400x' + ext;
      });
      image =
        '<div class="cross-sell-routine__image-wrap">' +
        '<img class="cross-sell-routine__image" src="' + src + '" alt="' + escapeHTML(product.title) + '" loading="lazy" width="400" height="400">' +
        '</div>';
    } else {
      image = '<div class="cross-sell-routine__image-wrap"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5" class="cross-sell-routine__placeholder-svg"><path d="M324.5 212.7H203c-1.6 0-2.8 1.3-2.8 2.8V308c0 1.6 1.3 2.8 2.8 2.8h121.6c1.6 0 2.8-1.3 2.8-2.8v-92.5c0-1.6-1.3-2.8-2.9-2.8zm1.2 95.3c0 .6-.5 1.2-1.2 1.2H203c-.6 0-1.2-.5-1.2-1.2v-92.5c0-.6.5-1.2 1.2-1.2h121.6c.6 0 1.2.5 1.2 1.2V308z"/><path d="M210.4 299.5H240v.1s.1 0 .2-.1h75.2v-76.2h-105v76.2zm1.6-74.6h101.8v73H212v-73z"/><path d="M232.3 254.8c4.7 0 8.5-3.8 8.5-8.5s-3.8-8.5-8.5-8.5-8.5 3.8-8.5 8.5 3.8 8.5 8.5 8.5zm0-15.4c3.8 0 6.9 3.1 6.9 6.9s-3.1 6.9-6.9 6.9-6.9-3.1-6.9-6.9 3.1-6.9 6.9-6.9z"/><path d="M278.6 255.3l-16.2 17.4-10.5-11.3-26.6 28.5H314l-35.4-34.6zm-52.4 32.7l26.2-28.1 10.5 11.3 16.2-17.4 33.2 32.4H215l11.2-18.2z"/></svg></div>';
    }

    var price = product.price_min
      ? formatMoney(product.price_min)
      : '';

    return (
      '<li class="cross-sell-routine__item">' +
      '<a class="cross-sell-routine__card" href="' + product.url + '" aria-label="' + escapeHTML(product.title) + '">' +
      image +
      '<div class="cross-sell-routine__info">' +
      '<p class="cross-sell-routine__title">' + escapeHTML(product.title) + '</p>' +
      '<p class="cross-sell-routine__price">' + price + '</p>' +
      '</div>' +
      '<span class="cross-sell-routine__cta" aria-hidden="true">Agregar</span>' +
      '</a>' +
      '</li>'
    );
  }

  function escapeHTML(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      var moneyFormat = (window.theme && window.theme.moneyFormat) || 'S/. ' + String.fromCharCode(123, 123) + 'amount' + String.fromCharCode(125, 125);
      return window.Shopify.formatMoney(cents, moneyFormat);
    }
    var amount = (cents / 100).toFixed(2);
    return 'S/. ' + amount;
  }

  function initCrossSell(section) {
    var sectionId = section.dataset.sectionId;
    var productId = section.dataset.productId;
    var limit = section.dataset.limit || '4';
    var list = section.querySelector('#cross-sell-list-' + sectionId);

    if (!productId || !list) return;

    var url =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + 'recommendations/products.json?product_id=' + productId + '&limit=' + limit + '&intent=related'
        : '/recommendations/products.json?product_id=' + productId + '&limit=' + limit + '&intent=related';

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('Recommendations request failed');
        return response.json();
      })
      .then(function (data) {
        var products = data && data.products;
        if (!products || products.length === 0) return; // keep fallback
        var html = products.map(buildCardHTML).join('');
        list.innerHTML = html;
      })
      .catch(function () {
        // Silently keep static fallback
      });
  }

  document.querySelectorAll('.cross-sell-routine').forEach(function (section) {
    initCrossSell(section);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lead-capture-popup"]) return;
  try {
    
  (function () {
    var STORAGE_KEY = 'shotty_popup_dismissed';
    var overlay = document.getElementById('shotty-popup-overlay');
    var configuredDelay = overlay ? parseInt(overlay.getAttribute('data-delay'), 10) || 30000 : 30000;
    var DELAY_MS = Math.max(configuredDelay, 30000);
    var readyToShow = false;
    var userIntentSeen = false;

    // Don't show if already dismissed or submitted
    if (localStorage.getItem(STORAGE_KEY) === 'true') return;

    var closeBtn = document.getElementById('shotty-popup-close');
    var content = document.getElementById('shotty-popup-content');
    var thankyou = document.getElementById('shotty-popup-thankyou');

    if (!overlay) return;

    function showPopup() {
      if (!readyToShow || !userIntentSeen || overlay.classList.contains('is-visible')) return;
      overlay.classList.add('is-visible');
    }

    function dismissPopup() {
      localStorage.setItem(STORAGE_KEY, 'true');
      overlay.classList.remove('is-visible');
    }

    function showThankYou() {
      localStorage.setItem(STORAGE_KEY, 'true');
      content.style.display = 'none';
      thankyou.style.display = 'block';
      // Auto-close after 3 seconds
      setTimeout(function () {
        overlay.classList.remove('is-visible');
      }, 3000);
    }

    function markIntent() {
      userIntentSeen = true;
      showPopup();
      window.removeEventListener('scroll', markIntent);
      window.removeEventListener('pointerdown', markIntent);
      window.removeEventListener('keydown', markIntent);
    }

    window.addEventListener('scroll', markIntent, { once: true, passive: true });
    window.addEventListener('pointerdown', markIntent, { once: true, passive: true });
    window.addEventListener('keydown', markIntent, { once: true });

    setTimeout(function () {
      readyToShow = true;
      if ('requestIdleCallback' in window) {
        requestIdleCallback(showPopup, { timeout: 4000 });
      } else {
        setTimeout(showPopup, 1200);
      }
    }, DELAY_MS);

    // Close button
    closeBtn.addEventListener('click', dismissPopup);

    // Click outside modal closes it
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) dismissPopup();
    });

    // Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-visible')) {
        dismissPopup();
      }
    });

    // Intercept form submit with fetch (AJAX) to avoid page redirect
    var form = overlay.querySelector('form');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var emailInput = form.querySelector('input[type="email"]');
        if (!emailInput || !emailInput.value) return;

        var formData = new FormData(form);

        fetch(form.action, {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        })
        .then(function (response) {
          // Shopify customer form always redirects (non-JSON); any 2xx or redirect is a success
          showThankYou();
        })
        .catch(function () {
          // Network error — still show thank you to avoid blocking UX
          showThankYou();
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
